/**
 * Persiste a preferência de menu lateral recolhido/expandido por usuário (EAS-249).
 * Mecanismo local (localStorage), sem dependência externa. A chave é namespaced pelo
 * id do usuário logado para que operadores diferentes no mesmo navegador mantenham
 * preferências independentes; quando não há usuário (ex.: tela de login) usa 'anon'.
 */
export class NavPreferenceUtil {

    private static keyFor(): string {
        try {
            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            const userId = currentUser && currentUser.id ? currentUser.id : 'anon';
            return 'navCollapsed:' + userId;
        } catch (e) {
            return 'navCollapsed:anon';
        }
    }

    /** Retorna a preferência salva, ou null se o usuário nunca escolheu (primeiro acesso). */
    public static load(): boolean {
        const raw = localStorage.getItem(NavPreferenceUtil.keyFor());
        if (raw === null) {
            return null;
        }
        return raw === 'true';
    }

    public static save(collapsed: boolean): void {
        localStorage.setItem(NavPreferenceUtil.keyFor(), String(collapsed));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_utils/nav-preference.util.ts